module.exports = "/_next/static/images/groundprobe-c6a3f6c4da95ae3a49df5cbbbedc17f1.png";